import { EventBus, Events } from '../games/nganya/utils/EventBus';

interface Props {
  soundEnabled: boolean;
  onToggleSound: () => void;
  onMenu: () => void;
}

export function PauseOverlay({ soundEnabled, onToggleSound, onMenu }: Props) {
  return (
    <div
      className="overlay"
      style={{ background: 'rgba(0,0,0,0.55)', justifyContent: 'center' }}
    >
      <div className="panel stack" style={{ width: 'min(360px, 100%)' }}>
        <h2 className="title" style={{ fontSize: '1.8rem', textAlign: 'center' }}>
          Paused
        </h2>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => EventBus.emit(Events.REQUEST_RESUME)}
        >
          Resume
        </button>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={() => EventBus.emit(Events.REQUEST_RESTART)}
        >
          Restart
        </button>
        <button type="button" className="btn btn-ghost" onClick={onToggleSound}>
          Sound: {soundEnabled ? 'On' : 'Off'}
        </button>
        <button type="button" className="btn btn-danger" onClick={onMenu}>
          Return to Menu
        </button>
      </div>
    </div>
  );
}
